import { CodeSection } from './code-subject-section';

export const CodeSectionRiconsocimentoList = [
  CodeSection.ATTO_CONSENSO_ATCOM,
  CodeSection.DATI_GENERALI_RICONOSCIMENTO,
  CodeSection.ATTO_CONSENSO_ATCOP,
  CodeSection.AUTORIZZAZIONE_RICONOSCIMENTO_PADRE,
  CodeSection.ATTO_RICONOSCIMENTO,
  CodeSection.ATTO_RICONOSCIMENTO_MADRE,
  CodeSection.ATTO_RICONOSCIMENTO_PADRE,
  CodeSection.ESTREMI_SENTENZA_PADRE,
  CodeSection.ESTREMI_SENTENZA_MADRE,
];
